// src/app/chatbot-embed/chatbot-embed.component.ts
import { Component, AfterViewInit, OnDestroy, Inject, PLATFORM_ID, OnInit, input } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { Renderer2 } from '@angular/core';
import { LoginService } from '@shared-angular/services/login.service';
import { RouteShareService } from '../shared/services/route-share.service';
import { NavigationEnd, Router } from '@angular/router';
import { waitSeconds } from '@reflact/tsutil';
import { EmbedBotBroadcastService } from '../embed-bot-broadcast.service';
import { EditorListItem } from '../shared/services/editor-items.service';


export type BOTINFOOBJECT = {
  CurrentNavigationArea: string;
  CurrentEditorName: string;
  CurrentEditorType: string;

};
@Component({
  selector: 'app-chatbot-embed',
  standalone: true,
  template: `
    <!-- Optionaler Container, falls das Widget einen Anker braucht -->
    <div id="chatbot-embed-anchor"></div>
  `
})
export class ChatbotEmbedComponent implements AfterViewInit, OnDestroy, OnInit {
  /** Deine Bot-URL (data-chatbot-url) */
  public readonly chatbotUrl = input('https://ki-toolbox.reflactportal.com/de/bot/68e60f9c10819bea091eeb1f');
  public readonly botId = input.required<string>();
  public readonly botName = input('🤖');

  /** Script-Quelle */

  public readonly scriptSrc = input('https://ki-toolbox.reflactportal.com/de/assets/embed.js');

  /** Optional: eindeutige ID um das Script zu erkennen */
  private scriptId = 'reflact-chatbot-embed-js';

  private addedByMe = false;
  private lastArea = "";
  private informationsChangedSub?: { unsubscribe: () => void };
  private routerEventSub?: { unsubscribe: () => void };
  constructor(
    private loginService: LoginService,
    public rss: RouteShareService,
    private router: Router,
    private chatbotEmbedService: EmbedBotBroadcastService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {



  }

  public ngOnInit(): void {
    if (!this.informationsChangedSub) {



      this.informationsChangedSub = this.chatbotEmbedService.informationsChanged$.subscribe((selectedEditor: EditorListItem | undefined) => {
        console.log(" THE CHANGE", selectedEditor);
        if (selectedEditor) {
          setTimeout(() => {
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
            const infos = window.embedBotInfos(selectedEditor);
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            RAGBOT.send("RAGAI.MSG.userBypass(" + infos + ")");
          }, 500);
        }
      });


      this.routerEventSub = this.router.events.subscribe(async (event) => {
        if (event instanceof NavigationEnd) {
          // Navigation ended, handle accordingly
          console.log('[ChatbotEmbed] NavigationEnd detected, re-initializing chatbot embed.');
          await waitSeconds(0.5); // Kurze Wartezeit, damit die Seite stabil ist
          // TRIGGER BEIM WECHSEL DES BEREICHS
          // @ts-expect-error
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          RAGBOT.send("RAGAI.MSG.userBypass(' " + window.embedBotInfos() + " ')");
        }
      });
    }

  }

  private getEmbedBotInfos(selectedEditor: EditorListItem | undefined): string {
    if (document.querySelector(".nav-link.active") == null) return "";
    const navLink = document.querySelector(".nav-link.active");
    let bereich: string = navLink instanceof HTMLElement ? navLink.innerText : "";
    bereich = bereich.replace(/[\r\n]+/g, ' ').trim();

    const editorDropdown = document.querySelector("#blockly-file-select-dropdown");
    let editorName: string = editorDropdown instanceof HTMLElement ? editorDropdown.innerText : "";
    editorName = editorName.replace(/[\r\n]+/g, ' ').trim();

    /*     if (editorName) {
          if (!editorName.includes("JS")) {
            editorName = "STAGE " + editorName;
          }
          bereich += " | Editor: " + editorName;
        } */

    const isblocky = window.location.pathname.includes("/blockly");


    let type = "Global JS";
    let wenndesc = "";
    if (selectedEditor) {
      if (selectedEditor.uniqueId.startsWith("stage_")) {
        type = "Stage";
      }
      if (selectedEditor.uniqueId.startsWith("fusion_")) {
        type = "Fusion View";
      }
      if (selectedEditor.uniqueId.startsWith("ifthen_")) {
        type = "Wenn-Dann Block";
        wenndesc = (selectedEditor as EditorListItem & { description?: string }).description ?? "";
      }
    }

    const editorType = type;
    editorName = wenndesc ? wenndesc : editorName;
    const botInfos: BOTINFOOBJECT = {
      CurrentNavigationArea: bereich,
      CurrentEditorType: isblocky ? editorType : '',
      CurrentEditorName: isblocky ? editorName : ''

    };

    return JSON.stringify("navigation-details=" + JSON.stringify(botInfos));
  }

  public ngAfterViewInit(): void {

    console.log("[ChatbotEmbed] Constructor called");
    // @ts-expect-error
    window.embedBotInfos = this.getEmbedBotInfos;

    this.scriptId = 'reflact-chatbot-embed-js-' + this.botId();
    if (!isPlatformBrowser(this.platformId)) return; // SSR-Guard

    // Schon vorhanden?

    const existingSelector = `script#${this.scriptId}, script[src="${this.scriptSrc()}"]`;
    this.document.querySelector<HTMLScriptElement>(existingSelector);


    console.log("NO EXISTING, CREATE NEW");
    // Neu anlegen
    const s = this.renderer.createElement('script') as HTMLScriptElement;
    s.id = this.scriptId;
    s.src = this.scriptSrc();
    s.className = 'embedbot';
    s.defer = true; // i.d.R. gut für 3rd-party Embeds

    s.setAttribute('data-url', this.chatbotUrl());
    s.setAttribute('data-id', this.botId());
    s.setAttribute('data-name', this.botName());

    console.log("SET ATTRIBUTES");
    // Alle diese Varianten funktionieren:

    //    console.log("USER", this.loginService.loggedInUser.name);
    const userName = this.loginService.loggedInUser?.name ?? 'Gast';

    let message = "Hi, " + userName + "! Wie kann ich dir helfen?";
    message += "ich sehe du arbeitest gerade in " + this.rss.botConfig.name;

    const onloadFn = `function() {
      RAGBOT.send("RAGAI.MSG.botMessage('${message.replace(/'/g, "\\'")}')");
      RAGBOT.send("RAGAI.MSG.userBypass('" +window.embedBotInfos() + " ')");
    }`;
    console.log("ONLOAD FN:", onloadFn);
    s.setAttribute('data-onload', onloadFn);
    //    s.setAttribute('data-onopen', "function(){console.log('Geöffnet');}");
    //  s.setAttribute('data-onclose', "window.meinCallback");


    console.log("SET DATA ATTRIBUTES");
    s.onload = () => {
      // Optional: Debug
      // console.log('[ChatbotEmbed] Script geladen');
    };

    s.onerror = () => {
      console.error('[ChatbotEmbed] Script konnte nicht geladen werden:', this.scriptSrc());
    };

    // In <body> anhängen (oder <head>, beides geht)

    this.renderer.appendChild(this.document.body, s);
    this.addedByMe = true;
  }

  public ngOnDestroy(): void {

    if (this.informationsChangedSub) {
      this.informationsChangedSub.unsubscribe();
    }
    this.routerEventSub?.unsubscribe();
    if (!isPlatformBrowser(this.platformId)) return;



    // Falls du willst, dass das Script beim Verlassen wieder verschwindet:
    // (Wenn das Widget global bleiben soll, entferne diesen Block.)
    if (this.addedByMe) {
      const el = this.document.getElementById(this.scriptId);
      if (el) {
        this.renderer.removeChild(this.document.body, el);
      }
    }
  }
}
